import { computePerRowRoundedTotals, useGetTimesheetRows } from '@sit/client-shared';
import { useMemo } from 'react';

export const useTimesheetSummary = (timesheetId: string | undefined) => {
  const { data: timesheetRows } = useGetTimesheetRows(
    {
      pathParams: {
        id: timesheetId,
      },
    },
    { enabled: !!timesheetId },
  );
  const result = useMemo(() => {
    if (!timesheetRows) {
      return { totalHours: 0, billableHours: 0, nonBillableHours: 0 };
    }

    const entries = timesheetRows.flatMap((row) => row.entries ?? []);

    return computePerRowRoundedTotals(entries);
  }, [timesheetRows]);
  return result;
};
